import Image1 from '../../assets/assets/testimonial1.png';
import Image2 from '../../assets/assets/testimonial2.png';
import Image3 from '../../assets/assets/testimonial3.png';
import Image4 from '../../assets/assets/testimonial4.png';

export const Data = [
    {
        id: 4,
        image: Image4,
        title: 'Steve Becker | Senior Software Engineer',
        description: 
            'Jerome He was always more successful as the project manager in meeting deadlines and finishing tasks.',
    },
    {
        id: 1,
        image: Image1,
        title: 'Harry Lee | Software Developer',
        description: 
            'Jerome did really good job, all aspects of the project were follower step by step and with good results and performances.',
    },
    {
        id: 2,
        image: Image2,
        title: 'Sophie Clinton | Frontend Developer',
        description:
            'Jerome has extensive knowledge in all aspects of software engineering and development.',
    },
    {
        id: 3,
        image: Image3,
        title: 'Sara Cill | Software Engineer',
        description:
            'John sets an excellent example for others by pushing them to develop in their areas.',
    }
]